import { toast } from "react-toastify";
import { ApiConfiguration } from "../../services/http/api-configuration";
import ApiService from "../../services/http/api-service";

export const getTermsAndCondition = async (params) => {
	try {
		const res = await ApiService.get(
			ApiConfiguration.getTermsAndCondition + `?page_name=${params}`
		);
		return res.data;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};

export const contactUs = async (payload) => {
	try {
		const res = await ApiService.post(ApiConfiguration.contactus, payload);
		return res.data;
	} catch (err) {
		toast.error(err.response.data.message);
		throw new Error(err);
	}
};
